import {
  ajax
} from 'application/src/js/functions.js';
import Crop from './crop.js';

/**
 * @class
 * @param {number} args.rawmaterialid
 * @param {object} args.translations
 * @param {Mediator} args.mediator
 */
export default class Cropdata {
  constructor(args) {
    this.rawmaterialid = args.rawmaterialid;
    this.translations = args.translations;
    this.mediator = args.mediator;

    this.container = document.querySelector('.lp-content .cropdata');
    this.list = this.container.querySelector('.list');
    this.yearOut = this.container.querySelector('.date-year');

    this.requestUrl = '/app/ajax/ajaxLoadRelatedCropData';
    this.user = null;
    this.debugMode = true;
    this.hideClass = 'hide';
    this.maxShowAmount = 10;
    this.year = (new Date()).getFullYear() - 2;

    this.load()
      .then(response => {
        this.user = response.user;
        this.render(response.data);
        this.mediator.publish('finishedLoading');
      })
      .catch(e => {
        if (this.debugMode && e) console.log(e);
        this.mediator.publish('finishedLoading');
      });
  }

  load() {
    this.mediator.publish('startedLoading');

    return ajax(this.requestUrl, {
      rawmaterialid: this.rawmaterialid,
      sort_by: 'production_quantity DESC',
      year: this.year
    });
  }

  render(cropdata) {
    this.yearOut.innerHTML = this.year;
    if (cropdata.length) this.container.classList.remove(this.hideClass);
    this.list.innerHTML = '';

    cropdata.slice(0, this.maxShowAmount).map(data => {
      const cropElement = document.createElement('div');
      this.list.insertAdjacentElement('beforeend', cropElement);

      new Crop({
        parent: this,
        data: data,
        element: cropElement,
        translations: this.translations,
        user: this.user
      });
    });
  }
}